module.exports = __webpack_public_path__ + "static/media/back1.95ca59f4.png";